const Loader = () => {
	return (
		<div className="spinner">
			<div className="ball"></div>
		</div>
	)
}

export default Loader
